const componentsCommon=require("cb-components-common").default;
const request=componentsCommon.request;

export function getAnalystRatingCategoryList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/category-list",
        method: "get",
        params: _params
    });
}
export function getAnalystRatingFundCategoryList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund/category-list",
        method: "get",
        params: _params
    });
}
export function getAnalystRatingChart(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/analyst-rating",
        method: "get",
        params: _params
    });
}

function clone_d3_selection(selection, i) {
    var attr = selection.node().attributes;
    var length = attr.length;
    var node_name = selection.property("nodeName");
    var parent = d3.select(selection.node().parentNode);
    var parentOfParent = d3.select(parent.node().parentNode);
    var cloned = parentOfParent.insert(node_name, "#analystRatingChart")
            .attr("id", "cloneLegend");
    for (var j = 0; j < length; j++) { // Iterate on attributes and skip on "id"
    if (attr[j].nodeName == "id") continue;
    cloned.attr(attr[j].name,attr[j].value);
    }
    cloned.node().appendChild(selection.node().firstChild);
    return cloned;
}

export function analystRatingChart(id, result, params) {
    params.chartloading = true;
    let LineChart = window["mbc-line"];
    let container = d3.select(id);
    let tickValues = result.verticalAxis;
    let chart = new LineChart({
            "xAxisOrient": "bottom",
            "tooltip": true,
            "hasBenchmarks": true,
            "showGrayBands": false,
            "dottedBenchmarks": false,
            "defaultBenchmarkStyle": false,
            "stacked": false,
            "y1AxisOrient": "left",
            "y1AxisTicksAlign": "left",
            "legend": true,
            "y1TickSymbol": "(%) ",
            "breakpoint": "1000px",
            // "colors": ["#496BB3", "#EF7621", "#A5A4A4"],
            //"ticksNumber": 8,
            "y2": false,
            "yTickMargin": 20,
            "dottedLineNames": {
                "y1AxisData": false
            },
            "tickValues": tickValues
            //"tooltipTemplate": "<div>123</div>"
        }),
        dataset = {
            "xDomain": result.date,
            "y1AxisData": [{
                "name": result.fundName,
                "values": result.fund
            }, {
                "name": result.categoryName,
                "values": result.category
            }, {
                "name": result.benchmarkName,
                "values": result.benchmark
            }]
        };
   
    container.datum(dataset).call(chart.init());
    params.chartloading = false;
    d3.select(id + " .mbc-chart-legend-inner").attr("transform","translate(0,2)");
    d3.selectAll(id + " .lineDot").attr("opacity", "0");
    d3.selectAll(id + " .mbc-axis.mbc-axis-y1.mbc-axis-left .tick").style("opacity", "1");
    d3.selectAll(id + " .mbc-chart-group .line").each(function() {
    d3.select(this).attr("shape-rendering", "geometricPrecision").attr("stroke-linecap", "round").attr("stroke-linejoin", "round");
    });
    d3.select("#cloneLegend").remove();
    clone_d3_selection(d3.select(id + " .mbc-chart-legend.mbc-chart-legend-top"), 0);
    d3.select("#cloneLegend").style("margin-top", "10px").style("text-align","left").style("width","550px").style("font-size","14px");
    d3.select("#cloneLegend .mbc-legend").attr("width", "550px");
    d3.select(id + " .mbc-chart-legend.mbc-chart-legend-top").remove();
    d3.selectAll(id+" .mbc-axis.mbc-axis-x.mbc-axis-bottom .tick").each(function() {
        if(result.horizontalAixs.indexOf(this.textContent) < 0){
           this.remove();
        }
        else if(result.horizontalAixs.indexOf(this.textContent) == 0) {
            d3.select(this).select('text').attr("style", "text-anchor: start;");
        }
        else if(result.horizontalAixs.indexOf(this.textContent) == result.horizontalAixs.length - 1) {
            d3.select(this).select('text').attr("style", "text-anchor: end;");
        }
    });
}

export function getLatestAnalystRatingFund(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/analyst-rating/fund",
        method: "get",
        params: _params
    });
}

export function getAnalystRatingPeriod(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/analyst-rating/period",
        method: "get",
        params: _params
    });
}

export function getAnalystRatingPerformance(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/analyst-rating/performance",
        method: "get",
        params: _params
    });
}

export function getAnalystRatingReturn(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/analyst-rating/return",
        method: "get",
        params: _params
    });
}

export function getAnalystRatingRisk(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/analyst-rating/risk",
        method: "get",
        params: _params
    });
}


export function riskDistributionChart(id, dp, data, params) {
    params.riskLoading = true;
    let canvas = document.getElementById(id);
    var parent = d3.select(canvas.parentNode);
    let width = parent.node().offsetWidth;
    canvas.width = width;

    canvas.height = 150;
    let triangleHeight = 16;
    let triangleLength = 18;
    let rectangleWidth = 500;
    let rectangleHeight = 35;
    let rectangleOffset = 320;
    let rectangleVerticalOffset = 65;
    let fontSize = 14;
    let verticalSpace = 4;
    let horizontalSpace = 15;
    let textMarginLeft = 50;
    var context = canvas.getContext("2d");
    context.font='14px "微软雅黑"';
    context.fillText(dp, textMarginLeft, rectangleVerticalOffset + rectangleHeight/2 + fontSize/2);
    context.strokeStyle = "#DCDFE6";
    context.beginPath();
    context.moveTo(0, 0);
    context.lineWidth = 1;
    context.lineTo(0, canvas.height);
    context.stroke();
    context.closePath();

    context.fillStyle = "#F2F2F2";
    context.strokeStyle = "#0D63A5";
    context.fillRect(rectangleOffset, rectangleVerticalOffset, rectangleWidth, rectangleHeight);
    
    if(data.allMarkets.length > 0) {
        let minVal = data.allMarkets[0];
        let maxVal = data.allMarkets[data.allMarkets.length -1];
        let range = maxVal - minVal;
        for(let i = 0; i < data.allMarkets.length; i++) {
            let position = (data.allMarkets[i] - minVal)  / range * rectangleWidth + rectangleOffset;
            context.beginPath();
            context.moveTo(position, rectangleVerticalOffset);
            context.lineTo(position, rectangleHeight + rectangleVerticalOffset);
            context.stroke();
            context.closePath();
        }
        context.strokeStyle = "#FF0000";
        let position = (data.fund - minVal) / range * rectangleWidth  + rectangleOffset;
        context.beginPath();
        context.moveTo(position, rectangleVerticalOffset + rectangleHeight);
        context.lineTo(position, rectangleVerticalOffset);
        context.stroke();
        context.closePath();
        context.beginPath();
        context.strokeStyle = "#FFFFFF";
        context.lineTo(position-triangleLength/2, rectangleVerticalOffset - triangleHeight);
        context.lineTo(position+triangleLength/2, rectangleVerticalOffset - triangleHeight);
        context.lineTo(position, rectangleVerticalOffset);
        context.stroke();
        context.closePath();
        context.fillStyle = "#FF0000";
        context.fill();
        context.font='14px "微软雅黑"';
        context.textAlign = "center";
        context.fillText(data.fund.toFixed(2),position,rectangleVerticalOffset - triangleHeight - verticalSpace - 2);
        
        context.strokeStyle = "#000000";
        position = (data.category - minVal) / range * rectangleWidth  + rectangleOffset;
        context.beginPath();
        context.moveTo(position, rectangleVerticalOffset);
        context.lineTo(position, rectangleVerticalOffset + rectangleHeight);
        context.stroke();
        context.closePath();
        context.beginPath();
        context.strokeStyle = "#FFFFFF";
        context.lineTo(position-triangleLength/2, rectangleVerticalOffset + rectangleHeight + triangleHeight);
        context.lineTo(position+triangleLength/2, rectangleVerticalOffset + rectangleHeight + triangleHeight);
        context.lineTo(position, rectangleVerticalOffset + rectangleHeight);
        context.stroke();
        context.closePath();
        context.fillStyle = "#000000";
        context.fill();
        context.font='14px "微软雅黑"';
        context.textAlign = "center";
        context.fillText(data.category.toFixed(2),position, rectangleHeight + rectangleVerticalOffset + triangleHeight + verticalSpace + fontSize);
        context.textAlign = "right";
        context.fillText(minVal.toFixed(2),rectangleOffset - horizontalSpace, rectangleVerticalOffset + rectangleHeight/2 + fontSize/2);
        context.textAlign = "left";
        context.fillText(maxVal.toFixed(2),rectangleWidth + rectangleOffset + horizontalSpace, rectangleVerticalOffset + rectangleHeight/2 + fontSize/2);
    }
    else {
        context.fillStyle = "#909399";
        context.font='14px "微软雅黑"';
        context.textAlign = "center";
        context.fillText('暂无数据', rectangleOffset + horizontalSpace + rectangleWidth/2, rectangleVerticalOffset + rectangleHeight/2 + fontSize/2);
    }
    
    params.loading = false;
}

export function categoryChart(id, dp, params) {
    let canvas = document.getElementById(id);
    var parent = d3.select(canvas.parentNode);
    let width = parent.node().offsetWidth;
    let canvasSpace = 30;
    canvas.width = width;
    canvas.height = 370;
    let triangleHeight = 16;
    let triangleLength = 18;
    let textSpace = 20;
    let fontSize = 14;
    var context = canvas.getContext("2d");
    context.strokeStyle = "#FFFFFF";
    context.beginPath();
    context.moveTo(0, canvasSpace);
    context.lineTo(triangleLength, canvasSpace);
    context.lineTo(triangleLength/2, triangleHeight + canvasSpace);
    context.lineTo(0, canvasSpace);
    context.stroke();
    context.closePath();
    context.fillStyle = "#FF0000";
    context.fill();
    context.font='14px "微软雅黑"';
    context.textAlign = "left";
    context.fillText(dp,triangleLength + textSpace, fontSize-(triangleHeight-fontSize) + canvasSpace);

    let verticalSpace = 10;
    context.strokeStyle = "#FFFFFF";
    context.beginPath();
    context.moveTo(0, 2 * triangleHeight + verticalSpace + canvasSpace);
    context.lineTo(triangleLength, 2 * triangleHeight + verticalSpace + canvasSpace);
    context.lineTo(triangleLength/2, triangleHeight + verticalSpace + canvasSpace);
    context.lineTo(0, 2 * triangleHeight + verticalSpace + canvasSpace);
    context.stroke();
    context.closePath();
    context.fillStyle = "#000000";
    context.fill();
    context.font='14px "微软雅黑"';
    context.textAlign = "left";
    context.fillText("同类平均",triangleLength + textSpace, 2 * triangleHeight + verticalSpace + canvasSpace);    
}